var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-rounded tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-grey-200 tw-flex-wrap tw-gap-2",class:{ 'tw-gap-2': _vm.imagesToShow.length > 1, 'tw-rounded-full': _vm.rounded },style:({
    width: _vm.width ? (_vm.width + "px") : undefined,
    height: _vm.height ? (_vm.height + "px") : undefined
  })},_vm._l((_vm.imagesToShow),function(img,index){return _c('CImg',{key:("img-" + index),staticClass:"tw-flex tw-select-none",class:[
      _vm.widthClass,
      _vm.heightClalss,
      { 'tw-w-full': index === 2 && _vm.fullWidth && _vm.imagesToShow.length === 3 }
    ],attrs:{"src":img,"object-fit":"cover","draggable":"false","lazy":_vm.lazy}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }